import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import dayjs from "dayjs";
import { loadLogoAsBase64 } from "./logoLoader";
import showdown from "showdown";
import htmlToPdfmake from "html-to-pdfmake";

pdfMake.vfs = pdfFonts.default;

export async function generateDashboardAiReportPdf(reportText) {
  const logoBase64 = await loadLogoAsBase64();

  // 1. Markdown → HTML
  const converter = new showdown.Converter();
  const html = converter.makeHtml(reportText);

  // 2. HTML → pdfMake (requiere window.document en navegadores)
  const pdfContent = htmlToPdfmake(html, { window: window });

  const docDefinition = {
    pageSize: "A4",
    pageMargins: [40, 100, 40, 40],

    header: {
      margin: [40, 20, 40, 20],
      table: {
        widths: [60, "*"],
        body: [
          [
            {
              image: logoBase64,
              width: 50,
              alignment: "left",
              rowSpan: 2,
            },
            {
              text: "UNIVERSIDAD NACIONAL DE ITAPÚA",
              style: "universityName",
              alignment: "center",
            },
          ],
          [
            {},
            {
              text: "Informe Ejecutivo de Convenios (IA)",
              style: "headerText",
              alignment: "center",
              margin: [0, 4, 0, 0],
            },
          ],
        ],
      },
      layout: "noBorders",
    },

    footer: (currentPage, pageCount) => ({
      columns: [
        {
          text: "Departamento de Asuntos Jurídicos - UNI",
          alignment: "left",
          fontSize: 8,
          margin: [40, 0, 0, 0],
        },
        {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: "right",
          fontSize: 8,
          margin: [0, 0, 40, 0],
        },
      ],
    }),

    content: [
      {
        text: `Generado automáticamente con IA el ${dayjs().format("DD/MM/YYYY")}`,
        fontSize: 9,
        italics: true,
        alignment: "right",
        margin: [0, 0, 0, 10],
      },
      ...pdfContent, // contenido transformado en lugar del texto plano
    ],

    styles: {
      universityName: { fontSize: 16, bold: true },
      headerText: { fontSize: 12, bold: true },
    },
  };

  pdfMake.createPdf(docDefinition).download("informe_dashboard_ia.pdf");
}
